///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.pricing_master_files = abcsetup.pricing_master_files || {};
abcsetup.pricing_master_files.index = abcsetup.pricing_master_files.index || {};

///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.pricing_master_files.index = {
    init() {
        abcsetup.setTitle('Pricing Master Files Index ');

        $(document).on('click',"a[value='ame']",function() {
            console.log("Generate AME Files");
            // Get Email checkbox value
            // Regenerate file
            abcsetup.blockUI(true);
            var send_emails = '';
            if ($("input[name='send_emails']").is(":checked")){
                send_emails = '?send_emails=true';
            }

            axios.post('/api/pricing_master_files/generate_ame'+send_emails)
            .then((response) => {
                // Generated new files, now reload
                $("#pricing_upload-table_filter .btn.buttons-reset").trigger('click');
                abcsetup.unblockUI();
                if ( response.data ) {
                    abcsetup.alerts.flashMessage((response.data.message_text ? response.data.message_text : 'Error'), (response.data.message_type ? response.data.message_type : 'warning'), false);
                } else {
                    abcsetup.alerts.flashMessage('An Unknown Error Occurred', 'warning', false);
                }
            }).catch(error => {
                abcsetup.unblockUI();
            });
        });

        // $(document).on('click',"a[value='hds']",function() {
        //     console.log("Generate HDS Files");
        //     // Get Email checkbox value
        //     // Regenerate file
        //     abcsetup.blockUI(true);
        //     var send_emails = '';
        //     if ($("input[name='send_emails']").is(":checked")){
        //         send_emails = '?send_emails=true';
        //     }

        //     axios.post('/api/pricing_master_files/generate_hds'+send_emails)
        //     .then((response) => {
        //         // Generated new files, now reload
        //         abcsetup.pricing_master_files.index.init_datatable();
        //         abcsetup.unblockUI();
        //         if ( response.data ) {
        //             abcsetup.alerts.flashMessage((response.data.message_text ? response.data.message_text : 'Error'), (response.data.message_type ? response.data.message_type : 'warning'), false);
        //         } else {
        //             abcsetup.alerts.flashMessage('An Unknown Error Occurred', 'warning', false);
        //         }
        //     }).catch(error => {
        //         abcsetup.unblockUI();
        //     });
        //  });

    },
}
